import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        actions: {
            background: theme.palette.grey[800],
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(1.5, 2),
            gridGap: theme.spacing(2),
        },
        consoleBody: {
            background: theme.palette.grey[900],
            overflowY: "auto",
            overflowX: "auto",
            padding: theme.spacing(2),
            scrollBehavior: "smooth",
            maxHeight: "300px",
            fontSize: "14px",
            color: theme.palette.common.white
        }
    }
});
